export default {
  updates: {
    investorRelations: 'Investor Relations',
  },
  meetings: {
    investorRelations: 'Investor Relations',
    meetings: 'Meetings',
    myMeetings: 'My Meetings',
    newMeeting: 'New Meeting',
    name: 'Name',
    date: 'Date',
    type: 'Type',
    status: 'Status',
    actions: 'Actions',
    meetingName: 'Meeting Name',
    meetingType: 'Meeting Type',
    meetingDate: 'Meeting Date',
    meetingTime: 'Meeting Time',
    location: 'Location',
    conferenceLink: 'Conference Link',
    addAttendee: 'Add an Attendee',
    back: 'Back',
    save: 'Save',
    addNewType: 'Add New Type',
    enterName: 'Enter Name',
    enterDays: 'Enter Days',
    addMeetingDate: 'Add Meeting Date',
    addMeetingTime: 'Add Meeting Time',
    locationPlaceholder: 'Enter Location',
    conferenceLinkPlaceholder: 'Enter Conference Link',
    noticeDays: 'Notice Days',
    edit: 'Edit',
    delete: 'Delete',
    editMeeting: 'Edit Meeting',
    deleteWarning: 'You are about to delete something important',
    deleteConfirmation: 'Are you certain about deleting',
    yesDelete: 'Yes, Delete',
    meetingDetails: 'Meeting Details',
    editInfo: 'Edit Info',
    cancelMeeting: 'Cancel Meeting',
    meetingAttendees: 'Meeting Attendees',
    attendeeName: 'Attendee Name',
    seenNotice: 'Seen Notice',
    ownership: 'Ownership',
    action: 'Action',
    attended: 'Attended',
    notAttended: 'Not Attended',
    yes: 'Yes',
    no: 'No',
    dateAndTime: 'Date and Time',
    discussedPoints: 'Discussed Points',
    theNextPhase: 'The next phase',
    havingContractWithFacebook: 'Having a contract with Facebook',
    meetingMinutes: 'Meeting Minutes',
    meetingMinutesDescription:
      'This is the final document that attendees will receive. Write down the meeting minutes and any other details that you may want to.',
    summary: 'Summary',
    vote: 'Vote',
    blank: 'Blank',
    attendeesInclusion: 'Attendees Inclusion',
    all: 'All',
    include: 'Include',
    exclude: 'Exclude',
    ownershipInclusion: 'Shareholders with more than X% ownership',
    minimumOwnership: 'Minimum ownership (%)',
    minimumOwnershipRequired: 'Please enter minimum ownership',
    minimumOwnershipInvalid: 'Please enter a percentage between 0 and 100',
    minimumOwnershipHelp: 'Only active shareholders holding MORE THAN this ownership percentage will be invited.',
    announcement: 'Announcement',
    announcementNotification:
      'This is the notification that present will receive it. All the points of discussion or voting that you added above will be added automatically to this document.',
    votingPoints: 'Voting points',
    votingPointsSubTitle: 'List all points that will be voted during the meeting.',
    addNewPoint: 'Add New Point',
    remove: 'remove',
    votingPointDescriptionPlaceholder: 'Enter voting point description',
    votingPointClausePlaceholder: 'Enter voting point clause',
    submit: 'Submit',
    preview: 'Preview',
    saveAndSend: 'Save & Send',
    deleteDraft: 'Delete Draft',
    finishMeeting: 'Finish Meeting',
    sendDraft: 'Send Draft',
    totalShares: 'Total Shares',
    selectExcludedUsers: 'Select excluded users',
    add: 'add',
    update: 'update',
    sendDelegate: 'Send Delegate',
    attendance: 'Attendance',
    delegateVoteToUser: 'Delegate Vote To User',
    selectDelegate: 'Select Delegate',
    results: 'Results',
    resultsByShareholder: 'Results by Shareholder',
    clause: 'Clause',
    pointDescription: 'Point Description',
    myVote: 'My Vote',
    meetingLink: 'Meeting Link',
    link: 'Link',
    saveAnnouncementDraft: 'Save Announcement Draft',
    saveMinutesDraft: 'Save Minutes Draft',
    saveMinutesOfMeeting: 'Save Minutes of Meeting',
    meetingGuests: 'Meeting Guests',
    validConferenceLinkError: 'Please enter a valid web link (e.g., https://example.com)',
    guests: 'Guests',
    meetingGuestsTooltip:
      "Guests will receive an email notifying them of the meeting but won't participate in the meeting.",
    attachments: 'Attachments',
    votingStartDate: 'Voting Start Date',
    addVotingStartDate: 'Add Voting Start Date',
    votingStartTime: 'Voting Start Time',
    addVotingStartTime: 'Add Voting Start Time',
    attendanceReport: 'Attendance Report',
    generatingAttendanceReport: 'Generating Attendance Report',
    retryAttendanceReport: 'Retry Attendance Report',
    attendanceReportFailed: 'Attendance report generation failed.',
    attendanceReportUnavailable: 'This attendance report expired or is unavailable. Generate it again.',
    value: 'Value',
    totalSharesPresentAttendees: 'Total Shares of Present Attendees',
    totalOwnershipPresentAttendees: 'Total Ownership of Present Attendees',
    shareholders: 'Shareholders',
  },
};
